import React from 'react';
import { createRoot } from 'react-dom/client';
import HallOfFamePage from '../components/tournaments/HallOfFamePage.jsx';
import TournamentsLayout from '../components/tournaments/TournamentsLayout.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <TournamentsLayout active="halloffame">
    <HallOfFamePage />
  </TournamentsLayout>
);
